'use client'
import {
  commonWhere
} from "./chunk-N55STAST.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/restaurants/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getRestaurants = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getRestaurants($lang: String, $limit: Int, $skip: Int, $where: RestaurantFilter, $order: [RestaurantOrder]) {
          restaurantCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
            total
            items {
              __typename
              sys { id }
              id
              title
              slug
              image11{${IMAGE_QUERY}}
              image31{${IMAGE_QUERY}}
              startingPrice
              currencyCode
              eventType
              buttonLink
              buttonLabel
              cardButtonLabel
              eventType
              authGaurd
              buttonLink
              carousalCollection(limit: 10) {
                items {${IMAGE_QUERY}}
              }
              location{${LOCATION_QUERY}}
              zone{
                id
                title
                slug
                zoneLogo{${IMAGE_QUERY}}
                sponsorLogo{${IMAGE_QUERY}}
              }
              isComingSoon
              specialPromotion
              schedule{${SCHEDULE_QUERY}}
            }
          }
        }
      `,
      __spreadProps(__spreadValues({
        order: "order_ASC"
      }, props), {
        lang: getContentfulSafeLocale(props.lang),
        where: __spreadValues(__spreadValues({}, commonWhere), props.where)
      })
    );
    return __spreadProps(__spreadValues({}, res.restaurantCollection), {
      settledAt: Date.now()
    });
  } catch (error) {
    throw new Exception({ error, name: "getRestaurantsException" });
  }
});
var useGetRestaurants = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getRestaurants", props],
    queryFn: () => getRestaurants(props)
  }, options));
};

export {
  getRestaurants,
  useGetRestaurants
};
//# sourceMappingURL=chunk-CSOIBYZD.mjs.map